var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"responsible-stay-app mt-4"},[_c(_setup.ResponsibleStay,{attrs:{"stationData":_setup.stationData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }